import { RioComponentType } from '@backoffice-frontend/graphql'

export const READ_ONLY_VEHICLE_COMPONENTS = [
  RioComponentType.VehicleVin,
  RioComponentType.VehicleType,
  RioComponentType.FleetName,
  RioComponentType.VehicleLicensePlate,
  RioComponentType.VehicleHubName,
  RioComponentType.VehicleMapVersion,
  RioComponentType.VehicleSdsAutonomousVehicle,
  RioComponentType.VehicleSdsConnectivity,
  RioComponentType.VehicleMissionControl,
  RioComponentType.VehicleCabinSafety,
  RioComponentType.VehicleOperatorInteraction,
  RioComponentType.VehicleBattery,
]
